<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">
    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newService()"
                aria-label="New Service">
            {{'New'|translate}}
        </button>
    </div>
    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/services" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">local_offer</mat-icon>
                <span>{{'All services'|translate}}</span>
            </a>
        </div>
    </div>
</div>
